import React from "react";
import { ChevronDown, ExternalLink } from "react-feather";
import {
  Actions,
  Chevron,
  CountBadge,
  HeaderRow,
  IconButton,
  IconSlot,
  Label,
  LabelGroup,
} from "./KgCatalogSectionHeader.styles";
import type { KgCatalogSectionHeaderProps } from "./KgCatalogSectionHeader.types";

export const KgCatalogSectionHeader: React.FC<KgCatalogSectionHeaderProps> = ({
  icon,
  label,
  isOpen,
  onToggle,
  onExternalLink,
  itemCount,
  className,
}) => {
  const handleExternalClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    onExternalLink?.();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onToggle();
    }
  };

  return (
    <HeaderRow
      className={className}
      role="button"
      tabIndex={0}
      aria-expanded={isOpen}
      onClick={onToggle}
      onKeyDown={handleKeyDown}
    >
      <LabelGroup>
        <IconSlot>{icon}</IconSlot>
        <Label>{label}</Label>
        {itemCount !== undefined && itemCount > 0 ? (
          <CountBadge>{itemCount}</CountBadge>
        ) : null}
        {onExternalLink ? (
          <IconButton
            type="button"
            aria-label={`Go to ${label}`}
            onClick={handleExternalClick}
          
          >
            <ExternalLink size={16} />
          </IconButton>
        ) : null}
      </LabelGroup>
      <Actions>
        <Chevron $isOpen={isOpen} aria-hidden>
          <ChevronDown size={20} />
        </Chevron>
      </Actions>
    </HeaderRow>
  );
};

export default KgCatalogSectionHeader;
